<template>
    <div class="CensusChanges">
        <h2>Census Changes Dashboard: <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="GetData()" class="olive-green-text pointer" /></h2>
        <b-row class="dashboard-row">
            <b-col md="4">
                <div class="form-group">
                    <label>Start Date:</label>
                    <flat-pickr v-model="Filters.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                </div>
                <div class="form-group">
                    <label>End Date:</label>
                    <flat-pickr v-model="Filters.EndDate" class="form-control" required :config="DateConfig"></flat-pickr>
                </div>
            </b-col>
            <b-col md="4">
                <div class="form-group">
                    <label>Program(s):</label>
                    <multiselect v-model="Filters.SubPrograms" :options="SubProgramOptions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Programs" label="text" track-by="text" :preselect-first="true" group-values="SubPrograms" group-label="CoreProgramName" :group-select="true">
                    </multiselect>
                </div>
            </b-col>
            <b-col md="4" v-if="false && DashboardData.StartCensus && CheckPermission('Dashboards.CensusChanges.Itemization')">
                <div class="form-group">
                    <label>Get Itemized Details:</label>
                    <button type="button" class="btn btn-primary form-control" @click="GetItemization">DOWNLOAD ITEMIZATION</button>
                </div>
            </b-col>
        </b-row>
        <b-row class="dashboard-row">
            <b-col md="4" v-for="option in DashboardData.FilterOptions">
                <div class="form-group">
                    <label>{{ option.Label }}</label>
                    <multiselect v-model="Filters.Drilldowns[option.Name]" :options="option.Options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="text" track-by="text" :preselect-first="false">
                    </multiselect>
                </div>
            </b-col>
        </b-row>
        <div v-if="DashboardData.StartCensus">
            <b-row class="dashboard-row">
                <b-col md="3">
                    <b-card title="STARTING CENSUS" align="center">
                        <h1>{{ DashboardData.StartCensus }}</h1>
                    </b-card>
                </b-col>
                <b-col md="3">
                    <b-card title="INTAKES" align="center">
                        <h1>{{ DashboardData.IntakesCount }}</h1>
                    </b-card>
                </b-col>
                <b-col md="3">
                    <b-card title="TERMINATIONS" align="center">
                        <h1>{{ DashboardData.TerminationsCount }}</h1>
                    </b-card>
                </b-col>
                <b-col md="3">
                    <b-card title="ENDING CENSUS" align="center">
                        <h1>{{ DashboardData.EndCensus }}</h1>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="dashboard-row">
                <b-col md="6">
                    <b-card title="Census Change (Count)" align="center">
                        <h1>{{ DashboardData.CensusChange }}</h1>
                    </b-card>
                </b-col>
                <b-col md="6">
                    <b-card title="Census Change (Percent)" align="center">
                        <h1>{{ DashboardData.CensusChangePercent }}%</h1>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="dashboard-row">
                <b-col>
                    <h3 class="center-text">CHILDREN DEMOGRAPHICS:</h3>
                </b-col>
            </b-row>
            <b-row class="dashboard-row">
                <b-col xl="2">
                    <b-card title="CENSUS BY SEX" align="center">
                        <div style="min-height: 365px;">
                            <apexchart type="bar"
                                       height="350"
                                       :options="SexGrouping.Options"
                                       :series="DashboardData.SexDistribution" />
                        </div>
                    </b-card>
                </b-col>
                <b-col xl="5">
                    <b-card title="CENSUS BY RACE" align="center">
                        <div style="min-height: 365px;">
                            <apexchart type="bar"
                                       height="350"
                                       :options="RaceGrouping.Options"
                                       :series="DashboardData.RaceDistribution" />
                        </div>
                    </b-card>
                </b-col>
                <b-col xl="5">
                    <b-card title="CENSUS BY ETHNICITY" align="center">
                        <div style="min-height: 365px;">
                            <apexchart type="bar"
                                       height="350"
                                       :options="EthnicityGrouping.Options"
                                       :series="DashboardData.EthnicityDistribution" />
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="dashboard-row">
                <b-col xl="12">
                    <b-card title="CENSUS BY AGE" align="center">
                        <div style="min-height: 365px;">
                            <apexchart type="bar"
                                       height="350"
                                       :options="SexGrouping.Options"
                                       :series="DashboardData.AgeDistribution" />
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <!--<b-row class="dashboard-row">
                <b-col xl="6">
                    <b-card title="CENSUS BY DESIGNATION" align="center">
                        <div style="min-height: 365px;">
                            <apexchart type="bar"
                                       height="350"
                                       :options="SexGrouping.Options"
                                       :series="DashboardData.DesignationDistribution" />
                        </div>
                    </b-card>
                </b-col>
                <b-col xl="6">
                    <b-card title="CENSUS BY TERRITORY" align="center">
                        <div style="min-height: 365px;">
                            <apexchart type="bar"
                                       height="350"
                                       :options="SexGrouping.Options"
                                       :series="DashboardData.TerritoryDistribution" />
                        </div>
                    </b-card>
                </b-col>-->
            </b-row>
        </div>
    </div>
</template>

<script>

    //import components
    import { EventBus } from '../../../services/event-bus.js';
    import apexchart from 'vue-apexcharts';
    import Multiselect from 'vue-multiselect'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);


    export default {
        props: [],
        data: function () {
            return {
                Filters: {
                    StartDate: "",
                    EndDate: "",
                    SubPrograms: [],
                    Drilldowns: {

                    }
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                DashboardData: {

                },

                SexGrouping: {
                    Options: {
                        chart: {
                            id: 'SexGrouping',
                            events: {
                                dataPointSelection: function (e, chart, opts) {
                                    console.log("you selected me!");
                                    console.log(e);
                                    console.log(chart);
                                    console.log(opts);
                                }
                            }
                        },
                        xaxis: {
                            type: 'category',
                        }
                    },
                },
                RaceGrouping: {
                    Options: {
                        chart: {
                            id: 'RaceGrouping'
                        },
                        xaxis: {
                            type: 'category',
                        }
                    },
                },
                EthnicityGrouping: {
                    Options: {
                        chart: {
                            id: 'EthnicityGrouping'
                        },
                        xaxis: {
                            type: 'category',
                        }
                    },
                },
                AgeGrouping: {
                    Options: {
                        chart: {
                            id: 'AgeGrouping'
                        },
                        xaxis: {
                            type: 'category',
                        }
                    },
                },
                DesignationGrouping: {
                    Options: {
                        chart: {
                            id: 'DesignationGrouping'
                        },
                        xaxis: {
                            type: 'category',
                        }
                    },
                },
                TerritoryGrouping: {
                    Options: {
                        chart: {
                            id: 'TerritoryGrouping'
                        },
                        xaxis: {
                            type: 'category',
                        }
                    },
                }
            };
        },
        methods: {
            GetData() {
                let vm = this;
                let params = {
                    StartDate: vm.Filters.StartDate,
                    EndDate: vm.Filters.EndDate,
                    SubPrograms: vm.Filters.SubPrograms.map(sp => sp.value).join(',')
                };
                //Handle drilldown
                if (this.DashboardData.FilterOptions) {
                    this.DashboardData.FilterOptions.forEach(function (item) {
                        params[item.Name] = vm.Filters.Drilldowns[item.Name] ? vm.Filters.Drilldowns[item.Name].map(i => i.value).join(',') : '';
                    });
                }
                
                vm.$store.commit("UI.BumpLoadsInProgress", 1);
                this.$MasterAPI.ExecuteRequest("GET", "Core/Dashboards/CensusChangesDashboard/GetData", params, this.GetDataSuccess, () => { }, true);
            },
            GetDataSuccess(reponse) {
                this.DashboardData = response.data.data;
            },
            GetItemization() {
                let vm = this;
                let params = {
                    TargetDate: vm.Filters.TargetDate,
                    SubPrograms: vm.Filters.SubPrograms.map(sp => sp.value).join(',')
                };
                //Handle drilldown
                if (this.DashboardData.FilterOptions) {
                    this.DashboardData.FilterOptions.forEach(function (item) {
                        params[item.Name] = vm.Filters.Drilldowns[item.Name] ? vm.Filters.Drilldowns[item.Name].map(i => i.value).join(',') : '';
                    });
                }
                this.$MasterAPI.ExecuteFileRequest("Core/Dashboards/CensusChangesDashboard/GetItemization", params);
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            apexchart,
            Multiselect,
            flatPickr
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptionsGroupedByCore"]();
            }
        },
        mounted() {
            //this.Filters.TargetDate = moment().format("YYYY-MM-DD");
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>